<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Net Asset Statements" />
    </template>
    <template v-if="loaded">
      <asset-statement-filter />
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import AssetStatementFilter from '@/components/AssetStatementFilter.vue'
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  async mounted () {
    // We need to determine the full list of users who require asset statements
    // as part of the onboarding process.

    // We need to get a list of users whom require statements.
    // Only get the directors and shareholders if user is a company.
    const params = {
      query: {
        user: this.$auth.user._id
      }
    }
    const requests = [this.$store.dispatch('core/asset-statements/list', params)]
    if (this.$auth.user.profile.isCompany) {
      requests.push(this.$store.dispatch('core/directors/list', params))
      requests.push(this.$store.dispatch('core/shareholders/list', params))
    }
    await Promise.all(requests)

    // Assign the users to the asset statements if they have not been already.
    const assign = async (profile) => {
      if (profile && this.assetStatements.filter(statement => statement.profile._id === profile._id).length === 0) {
        await this.$store.dispatch('core/asset-statements/save', { profile: profile._id, user: this.$auth.user._id })
      }
    }
    const assignments = [assign(this.$auth.user.profile)]

    if (this.$auth.user.profile.isCompany) {
      this.directors.map(({ profile }) => assignments.push(assign(profile)))
      this.shareholders.map(({ profile }) => assignments.push(assign(profile)))
    }

    await Promise.all(assignments)

    this.loaded = true
  },

  data: () => ({
    loaded: false
  }),

  components: {
    AssetStatementFilter,
    HeroHeader
  },

  computed: {
    ...mapState({
      assetStatements: store => store.core.assetStatements.rows,
      directors: store => store.core.directors.rows,
      shareholders: store => store.core.shareholders.rows
    })
  }
}
</script>
